module.exports = __webpack_public_path__ + "img/leaf4.676d9333.png";